selectedProducts = [];

function getVariantData(size, color) {
  const variants = variantData;
  if (!variants) return null;

  for (let variant of variants) {
    if (variant.size === size && variant.color === color) {
      return variant;
    }
  }
  return null;
}

function filterImages(imageAltTag) {
  const thumbs = document.querySelectorAll(".media__thumb");
  const slides = document.querySelectorAll(".product__media");

  let isFirstThumbMatch = true;
  let isFirstSlideMatch = true;

  thumbs.forEach((thumb) => {
    if (thumb.getAttribute('data-image-filter') === imageAltTag) {
      thumb.classList.remove("hide");

      if (isFirstThumbMatch) {
        thumb.classList.add("is-activated");
        isFirstThumbMatch = false; // Mark that the first thumb match has been found
      } else {
        thumb.classList.remove("is-activated");
      }
      
    } else {
      thumb.classList.add("hide");
      thumb.classList.remove("is-activated");
    }
  });

  slides.forEach((slide) => {    
    if (slide.getAttribute('data-image-filter') === imageAltTag) {
      slide.classList.remove("hide");
      if (isFirstSlideMatch) {
          slide.classList.add("is-selected");
          isFirstSlideMatch = false; // Mark that the first slide match has been found
      } else {
        slide.classList.remove("is-selected");
      }
    } else {
       slide.classList.add("hide");
       slide.classList.remove("is-selected");
    }
  });
}

const products = document.querySelectorAll(".bundle_product");

products.forEach((product) => {
  const product_id = product.getAttribute("data-product-id");

  const radioButtons = product.querySelectorAll('[type="radio"]');
  const selectDropdown = product.querySelector("select");
  const selectDropdownOptions = product.querySelectorAll("select option");
  const selectedOptionName = product.querySelector('[data-option-value]');
  
  // Function to update checkbox availability based on selected size and color
  function updateCheckboxAvailability(sizeDropdown, colorRadios) {
    const selectedSize = sizeDropdown.value;
    const selectedColor = product.querySelector(
      'input[type="radio"]:checked'
    )?.value;

    selectDropdownOptions.forEach((option) => {
      const variant = getVariantData(option.value, selectedColor);
      if (variant && !variant.available) {
        option.disabled = true;
      } else {
        option.disabled = false;
      }
    });

    // Update color checkboxes based on selected size
    colorRadios.forEach((colorRadio) => {
      const color = colorRadio.value;
      const variant = getVariantData(selectedSize, color);

      if (variant && !variant.available) {
        colorRadio.disabled = true;
      } else {
        colorRadio.disabled = false;
      }
    });
  } // updateCheckboxAvailability()

  radioButtons.forEach((radiobutton) => {
    radiobutton.addEventListener("change", (event) => {
      const selectedColor = event.target.value;
      const selectedSize = selectDropdown.value;

      selectedOptionName.textContent = selectedColor;

      const variant = getVariantData(selectedSize, selectedColor);
      
      if (variant && variant.available) {
        const existingProductIndex = selectedProducts.findIndex(
          (product) => product.product_id === product_id
        );

        if (existingProductIndex !== -1) {
          selectedProducts[existingProductIndex].id = variant.variant_id;
        } else {
          selectedProducts.push({
            product_id: product_id,
            id: variant.variant_id,
            quantity: 1,
          });
        }
      }

      updateCheckboxAvailability(selectDropdown, radioButtons);
      filterImages(event.target.getAttribute('data-image-filter'));
      
    });
  });

  selectDropdown.addEventListener("change", () => {
    product.classList.remove('has-error');
    const selectedColor = product.querySelector(
      'input[type="radio"]:checked'
    )?.value;
    const selectedSize = selectDropdown.value;

    const variant = getVariantData(selectedSize, selectedColor);

    if (variant && variant.available) {
      const existingProductIndex = selectedProducts.findIndex(
        (product) => product.product_id === product_id
      );

      if (existingProductIndex !== -1) {
        selectedProducts[existingProductIndex].id = variant.variant_id;
      } else {
        selectedProducts.push({
          product_id: product_id,
          id: variant.variant_id,
          quantity: 1,
        });
      }
    }

    updateCheckboxAvailability(selectDropdown, radioButtons);    
    console.log(selectedProducts);
  });

  // filterImages(product.querySelector(
  //     'input[type="radio"]:checked'
  //   ).getAttribute('data-image-filter'));

  updateCheckboxAvailability(selectDropdown, radioButtons);
  
});


const buttons = document.querySelectorAll("button");

const productOrder = ["product_1", "product_2", "product_3"];

document.querySelector(".button_buttons").addEventListener("click", (event) => {

  
  if (event.target.classList.contains("button")) {

    buttons.forEach(button => {
      button.classList.remove("_active");
    });

    document.querySelector('[data-button-price]').textContent = event.target.getAttribute('data-pack-price');
    document.querySelector('[data-product-price]').textContent = event.target.getAttribute('data-pack-price');

    if(document.querySelector('[data-price-off-amount]')) {
      
    
    
    document.querySelector('[data-price-off-amount]').textContent = event.target.getAttribute('data-pack-discount');

    if(event.target.getAttribute('data-pack-discount')) {
      document.querySelector('[data-price-off]').classList.remove("hidden");
    } else {
      document.querySelector('[data-price-off]').classList.add("hidden");
    }
    }
    

    event.target.classList.add("_active");
    
    const pack = parseInt(event.target.getAttribute("data-pack"), 10);

    // Create a set of product IDs to keep based on the pack number
    const productIdsToKeep = new Set(productOrder.slice(0, pack));

    // Filter the selectedProducts array to keep only the products with product_id in the set
    selectedProducts = selectedProducts.filter((product) =>
      productIdsToKeep.has(product.product_id)
    );

    console.log("Selected Products:", selectedProducts);

    // Get all product elements
    const products = document.querySelectorAll(".bundle_product");

    products.forEach((product, index) => {
      const productId = product.getAttribute("data-product-id");

      if (index < pack) {
        product.classList.add("selected");
      } else {
        product.classList.remove("selected");

        // Reset radio buttons
        const radios = product.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => (radio.checked = false));

        // Reset dropdowns
        const selects = product.querySelectorAll("select");
        selects.forEach((select) => (select.selectedIndex = 0));
      }
    });
  }
});

const addToCartButton = document.querySelector("[bundle-add-to-cart]");

addToCartButton.addEventListener("click", function (e) {
      e.preventDefault();
      let hasError = false; // Initialize error flag
      products.forEach( product => {
        
        if (product.classList.contains("selected")) {
          
          const dropdown = product.querySelector("select");
          console.log(dropdown.value);
           if (dropdown && dropdown.value === "") {
              product.classList.add('has-error');
              hasError = true; // Set error flag
          } else {
              product.classList.remove('has-error');
          }
          
        }
      });

  if (hasError) {
      // Stop further code execution if there is an error
      console.log("Validation failed. Stopping further execution.");
      return;
  }
  
       addToCartButton.classList.add('loading');
  
      const lineItems = selectedProducts.map((product) => {
        return {
          id: product.id,
          quantity: 1,
        };
      });

      console.log(lineItems);

      const cartData = {
        cart: {
          items: lineItems,
        },
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(cartData.cart),
      })
        .then((response) => response.json())
        .then((data) => {
          // window.location.href = "/cart";
          console.log(data);
          addToCartButton.classList.remove('loading');

        })
        .catch((error) => {
          // Handle errors
          console.error(error);
        });
    });
